import { useState } from 'react';

const faqs = [
  {
    question: '桃桃漫画网上的韩国漫画都是免费的吗？',
    answer: '是的！桃桃漫画网上的所有韩国漫画都是完全免费阅读的，无需付费订阅，也没有隐藏收费。我们致力于为漫画爱好者提供优质的免费韩漫在线阅读服务。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式漫画是韩国漫画（Webtoon）的独特阅读方式，您只需要向下滑动页面即可连续阅读，无需翻页。这种阅读方式更适合手机和电脑浏览，让阅读体验更加流畅自然。',
  },
  {
    question: '漫画内容是否有删减？',
    answer: '桃桃漫画网坚持提供无删减的韩国漫画内容，保留原版漫画的所有画面和情节，让读者能够完整地体验原作者的创作意图和故事魅力。',
  },
  {
    question: '网站多久更新一次漫画？',
    answer: '我们每天都会更新连载中的韩国漫画最新章节。热门作品的更新频率通常为每周一到两话，具体更新频率取决于原作在韩国的连载进度。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！桃桃漫画网采用了响应式设计，完美适配手机、平板和电脑等所有设备。在手机上阅读时，下拉式操作更加方便，随时随地畅享漫画乐趣。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型的漫画，也可以使用搜索功能输入漫画名称或关键词来查找。我们还有热门推荐和最新更新栏目帮助您发现好作品。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-1">关于桃桃漫画网的使用说明</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => toggle(idx)}
              >
                <h4 className="text-sm font-medium text-foreground-800">{faq.question}</h4>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FAQ Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}